// GTM Script Loader Component
// Add this to your App.tsx or main layout

import React, { useEffect } from 'react';

interface GTMScriptProps {
  gtmId: string;
  enabled?: boolean;
}

const GTMScript: React.FC<GTMScriptProps> = ({ gtmId, enabled = true }) => {
  useEffect(() => {
    if (!enabled || !gtmId) {
      console.warn('[GTM] GTM is disabled or GTM ID is missing');
      return;
    }

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    // Load GTM script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);

    console.log(`[GTM] Script loaded with ID: ${gtmId}`);

    return () => {
      // Cleanup on unmount
      const existingScript = document.querySelector(`script[src*="${gtmId}"]`);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [gtmId, enabled]);

  if (!enabled || !gtmId) {
    return null;
  }

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        title="Google Tag Manager"
      />
    </noscript>
  );
};

export default GTMScript;
